<template>
  <div>
    <b-table
      :items="items"
      :fields="fields"
      responsive
      :busy="isLoading"
      class="scroll-bar-mkt">
      <template #table-busy>
        <div class="text-center text-danger my-2">
          <b-spinner class="align-middle"></b-spinner>
        </div>
      </template>
      <template #cell(price)="row">
        <h3>
          {{ Number(row.item.price) | number }}
          <span class="h5 text-muted"> บาท</span>
        </h3>
      </template>
    </b-table>
    <b-row>
      <b-col class="d-flex justify-content-center">
        <b-pagination
          v-model="pagination.currentPage"
          :disabled="isLoading"
          :total-rows="pagination.totalRows"
          :per-page="pagination.perPage"
          aria-controls="my-table"
          class="mt-3"
          @change="(page) => getJobExpensesDriver(page, jobId)"></b-pagination>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import jobServices from "@/api/job.service.js";

export default {
  props: {
    jobId: {
      default: true,
    },
  },
  data() {
    return {
      isLoading: false,
      pagination: {
        currentPage: 1,
        perPage: 10,
        totalRows: 0,
      },
      fields: [
        {
          key: "name",
          label: "รายละเอียด",
          class: "text-left h5",
        },
        {
          key: "price",
          label: "จำนวนเงิน",
          class: "text-center h5",
        },
      ],
      items: [],
    };
  },
  created() {
    // this.getJobExpensesDriver(1, this.jobId);
  },
  watch: {
    jobId(newJobId) {
      if (newJobId) {
        this.getJobExpensesDriver(1, newJobId);
      }
    },
  },
  methods: {
    async getJobExpensesDriver(page = 1, jobId = null) {
      this.isLoading = true;
      try {
        const { data } = await jobServices.getJobExpensesDriver({
          page,
          job_id: jobId,
        });

        this.items = data.data.items;
        this.pagination.totalRows = data.data.meta.totalItems;
        this.pagination.perPage = data.data.meta.itemsPerPage;
        this.pagination.currentPage = data.data.meta.currentPage;
        this.isLoading = false;
      } catch (error) {}
    },
  },
};
</script>
